import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetNarratorByIdMultilingual = () => {
  return useContentSelector(({ narrators }) => narrators.byIdMultilingual);
};

export const useCreateNarratorMultilingual = () => {
  return useContentSelector(({ narrators }) => narrators.createMultilingual);
};

export const useEditNarratorMultilingual = () => {
  return useContentSelector(({ narrators }) => narrators.editMultilingual);
};
